import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { AlertNotice } from 'shared/components';
import { ROOM_STATUS } from 'shared/constants';
import './RoomTestMaterials.scss';

class RoomTestMaterials extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    const { roomGroupedMaterials, roomTypeMaterialTypes, roomStatus } = this.props;
    let infoMessage;
    if (roomGroupedMaterials.length) {
      const isMatchedWithRoomType = roomGroupedMaterials.some(
        (materialGroup) =>
          !roomTypeMaterialTypes.some((type) => type.id === materialGroup.id) &&
          materialGroup.roomMaterials.length
      );
      infoMessage = isMatchedWithRoomType
        ? this.props.t('materialChain.materialNotMatchRoomType')
        : this.props.t('roomDashboard.materialChain.infoMessage');
    } else {
      infoMessage = this.props.t('roomDashboard.materialChain.noTestMaterials');
    }

    return (
      <div className="mt-24 mb-24">
        <h5>{this.props.t('roomDashboard.materialChain.title')}</h5>
        <div className="border-box-silver">
          <div>
            {roomStatus.status === ROOM_STATUS.closed ? (
              <AlertNotice
                message={this.props.t('roomDashboard.materialChain.successMessage')}
                type="success"
              />
            ) : (
              <AlertNotice message={infoMessage} />
            )}
            <div className="room-materials-container">
              {roomGroupedMaterials.map((materialGroup) => {
                if (
                  !materialGroup.roomMaterials.length &&
                  roomStatus.roomType &&
                  roomTypeMaterialTypes.length &&
                  !roomTypeMaterialTypes.some((type) => type.id === materialGroup.id)
                ) {
                  return null;
                }
                return (
                  <div key={materialGroup.id} className="material-group">
                    <p className="mb-2 fw-bold">{materialGroup.name}</p>
                    {materialGroup.roomMaterials.length ? (
                      materialGroup.roomMaterials.map((material, idx) => (
                        <div key={idx}>
                          {material.rangeBegin} - {material.rangeEnd} ({material.count})
                        </div>
                      ))
                    ) : (
                      <div>
                        {materialGroup.code === 'writing' && !roomStatus.roomType
                          ? this.props.t('roomDashboard.materialChain.selectRoomType')
                          : this.props.t('roomDashboard.materialChain.noTestBooklets')}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

RoomTestMaterials.propTypes = {
  t: PropTypes.func.isRequired,
  roomGroupedMaterials: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  roomTypeMaterialTypes: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
    })
  ),
  roomStatus: PropTypes.shape({
    status: PropTypes.string,
    roomType: PropTypes.any,
  }),
  room: PropTypes.object,
  roomId: PropTypes.string.isRequired,
};

export default withTranslation()(RoomTestMaterials);
